<template>
    <v-card class="ma-2 mx-xsmall-0 custom-card" color="white">
        <v-card-text class="text-h6 text-center black--text pa-0">
            <!-- <Email class="mb-4" /> -->

            <v-row v-if="counter > 1" align="center" justify="center" align-content="space-between" no-gutters>
                <v-tabs v-model="tab" :background-color="`${backgroundColor} lighten-1`" active-class="v-tab-selectected" color="white" centered @change="savePreference"
                    class="mb-1" grow>
                    <v-tabs-slider color="secondary"></v-tabs-slider>
                    <v-tab key="1" href="#stripe" v-if="stripe">
                        Cartão
                    </v-tab>
                    <v-tab key="2" href="#mercadopago" v-if="mercadopago">
                        Cartão
                    </v-tab>
                    <v-tab key="3" href="#mercadopagopix" v-if="mercadopagopix">
                        PIX
                    </v-tab>
                    <v-tab key="4" href="#pagarmepix" v-if="pagarmepix">
                        PIX
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" class="text-center white">
                    <v-tab-item key="1" value="stripe">
                        <v-col cols="12" align="center">
                            <ButtonStripe :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                        </v-col>
                    </v-tab-item>
                    <v-tab-item key="2" value="mercadopago">
                        <v-col cols="12" align="center">
                            <ButtonMercadoPago :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                        </v-col>
                    </v-tab-item>
                    <v-tab-item key="3" value="mercadopagopix">
                        <v-col cols="12" align="center">
                            <ButtonMercadoPagoPix :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                        </v-col>
                    </v-tab-item>
                    <v-tab-item key="4" value="pagarmepix">
                        <v-col cols="12" align="center">
                            <ButtonMercadoPagoPix :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" operator="pagarmepix" />
                        </v-col>
                    </v-tab-item>
                </v-tabs-items>
            </v-row>
            <v-row align="center" justify="center" align-content="space-between" v-else-if="counter === 1" class="ml-1" no-gutters>
                <v-col cols="12" align="center" v-if="mercadopago">
                    <ButtonMercadoPago :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                </v-col>
                <v-col cols="12" align="center" v-if="stripe">
                    <ButtonStripe :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                </v-col>
                <v-col cols="12" align="center" v-if="mercadopagopix">
                    <ButtonMercadoPagoPix :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" />
                </v-col>
                <v-col cols="12" align="center" v-if="pagarmepix">
                    <ButtonMercadoPagoPix :charger="charger" :price="price" :plugNumber="plug" :chargerName="chargerName" operator="pagarmepix" />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ButtonStripe from "@/components/shared/Payment/ButtonStripe";
import ButtonMercadoPago from "@/components/shared/Payment/ButtonMercadoPago";
import ButtonMercadoPagoPix from "@/components/shared/Payment/ButtonMercadoPagoPix";
// import Email from "@/components/shared/Payment/Email";

export default {
    name: "PaymentOptions",

    components: {
        ButtonStripe,
        ButtonMercadoPago,
        ButtonMercadoPagoPix,
        // Email,
    },

    props: {
        charger: {
            required: true,
        },
        chargerName: {
            required: true,
        },
        price: {
            required: true,
        },
        plug: {
            required: true,
        },
        backgroundColor: {
            type: String,
            default: "warning",
        },
    },

    data() {
        return {
            tab: null,
            mercadopago: false,
            mercadopagopix: false,
            pagarmepix: false,
            stripe: false,
            method: null
        };
    },

    mounted() {
        this.getPreference();
        this.getPayOption();
        this.$eventHub.$on("makeLogin", this.getPreference);
    },

    computed: {
        counter() {
            return [this.mercadopago, this.stripe, this.mercadopagopix, this.pagarmepix].filter(Boolean).length;
        },
    },

    methods: {
        savePreference() {
            if (this.tab) {
                this.method = this.tab;
            }
            this.$store.commit("CHANGE_PAYMENT_METHOD", this.method);
        },
        getPreference() {
            if (this.$store.state.payment.method) {
                this.method = this.$store.state.payment.method;
            }
        },
        getPayOption() {
            this.$http
                .get("api/v2/payment-detail/" + this.chargerName)
                .then((result) => {
                    if (result) {
                        this.stripe = result.stripe;
                        this.mercadopago = result.mercadopago;
                        this.mercadopagopix = result.mercadopagopix;
                        this.pagarmepix = result.pagarmepix === true;

                        if (this.method && result[this.method]) {
                            this.tab = this.method;
                        }
                    }
                });
        }
    }
};
</script>

<style scoped>
.v-tab-selectected {
    /* background-color: white !important; */
    /* color: var(--v-primary-base); */
    color: white !important;
    /* border: 2px solid var(--v-secondary-base); */
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 1);
    /* Adiciona o efeito de elevação */
    /* color: black !important; */
}

.custom-card {
    max-width: 600px;
}
</style>